/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".picker-selection[_ngcontent-%COMP%]{margin-right:1.2rem;width:calc(100% - 40px)}\n/*# sourceMappingURL=pick-one.component.css.map*/"];
export { styles as styles };
